export const UPDATE_NOTIFICATION_REQUEST = "UPDATE_NOTIFICATION_REQUEST";
export const UPDATE_NOTIFICATION_SUCCESS = "UPDATE_NOTIFICATION_SUCCESS";
export const UPDATE_NOTIFICATION_FAIL = "UPDATE_NOTIFICATION_FAIL";

export const NOTIFICATION_STATUS_REQUEST = "NOTIFICATION_STATUS_REQUEST";
export const NOTIFICATION_STATUS_SUCCESS = " NOTIFICATION_STATUS_SUCCESS";
export const NOTIFICATION_STATUS_FAIL = " NOTIFICATION_STATUS_FAIL";
